import React, { lazy, useEffect, useState } from 'react';
import Header from './Header';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import CircularProgressWithLabel from '../components/KenCircularProgress/CircularProgressWithLabel';
import ThankYouPage from './ThankYouPage';
import { LightenDarkenColor } from '../utils/componentHelper';
import {
  getJobRole,
  getApplicationById,
  getDirector,
  getRecognitionOfInstitute,
  getAspect,
  getUploadDetails
} from '../utils/ApiService';
import { Hidden, Typography } from '@material-ui/core';
import { importComponent, getStepperConfig } from '../utils/configHelper';
import MaterialIcon from '../components/MaterialIcon';
import configContext from '../utils/config';
import { GLOBAL } from '../utils/constants';
import { useTheme } from 'styled-components';

const useStyles = makeStyles((theme) => {
  const { config } = React.useContext(configContext);
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '30px',
    },
    button: {
      marginRight: theme.spacing(1),
      padding: '8px 12px 8px 12px',
      textTransform: 'none',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
    },
    buttonTypo: {
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
    },
    labelSteplabel: {
      color: theme.palette.KenColors.neutral400,
      fontSize: '14px !important',
      lineHeight: '20px',
      marginLeft: 16,
    },
    activeStepLabel: {
      fontWeight: 'bold !important',
      fontSize: '14px',
      lineHeight: '20px',
      color: `${theme.palette.KenColors.primary} !important`,
    },
    completed: {
      fontSize: '14px',
      lineHeight: '20px',
      color: `${theme.palette.KenColors.neutral400} !important`,
    },
    root2: {
      padding: 24,
      zIndex: 1,
      position: 'relative',
    },
    root3: {
      boxShadow: `inset 3px 0px 0px ${theme.palette.KenColors.primary}`,
      backgroundColor:
        config?.customization?.palette?.activeStepBgColor ||
        `${LightenDarkenColor(
          theme.palette.KenColors.primary,
          GLOBAL.COLORS.SIDENAV.STEP_COLOR.RANGE
        )}`,
      // backgroundColor: `${LightenDarkenColor(
      //   theme.palette.KenColors.primary,
      //   GLOBAL.COLORS.SIDENAV.STEP_COLOR.RANGE
      // )}`,
    },
  };
});
const ColorlibConnector = withStyles((theme) => ({
  root: {
    flex: 0,
    padding: 0,
  },
  active: {
    '& $line': {
      backgroundColor: theme.palette.KenColors.tertiaryGreen200,
    },
  },
  completed: {
    '& $line': {
      backgroundColor: theme.palette.KenColors.tertiaryGreen200,
    },
  },
  line: {
    zIndex: 2,
    position: 'absolute',
    marginLeft: '41px',
    marginTop: '-25px',
    width: 5,
    height: 49,
    border: 0,
    backgroundColor: theme.palette.KenColors.neutral40,
    borderRadius: 1,
  },
}))(StepConnector);

const useColorlibStepIconStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.KenColors.white,
    zIndex: 1,
    color: theme.palette.KenColors.white,
    width: 66,
    height: 66,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    border: `7px solid ${theme.palette.KenColors.neutral40}`,
  },
  active: {
    backgroundColor: theme.palette.KenColors.white,
    border: `6px solid ${theme.palette.KenColors.neutral40}`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed1: {
    border: `6px solid ${theme.palette.KenColors.tertiaryGreen200}`,
    backgroundColor: theme.palette.KenColors.white,
  },
  completed: {
    border: `1px solid ${theme.palette.KenColors.white}`,
    borderRadius: '50%',
    marginTop: 3,
  },
  stepIcons: {
    marginTop: '5px',
    height: '40px',
    width: '40px',
    // padding: "2px",
  },
}));

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const theme = useTheme();
  const { active, completed, stepperConfig } = props;

  const icons = stepperConfig.map((config, index) => (
    <CircularProgressWithLabel
      value={50}
      size={66}
      thickness={4}
      label={
        <MaterialIcon
          icon={config?.icon}
          className={classes.stepIcons}
          fallBackIcon={index + 1}
        />
      }
      color="inherit"
    />
  ));

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed1]: completed,
      })}
    >
      {completed ? (
        <div
          className={classes.completed}
          style={{
            color: theme.palette.KenColors.tertiaryGreen200,
          }}
        >
          {icons[String(props.icon - 1)]}
        </div>
      ) : (
        <div
          style={{
            color: active
              ? theme.palette.KenColors.tertiaryGreen200
              : theme.palette.KenColors.neutral40,
          }}
        >
          {icons[String(props.icon - 1)]}
        </div>
      )}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const getSteps = (stepperConfig) =>
  stepperConfig.map((config) => config?.label?.toUpperCase());

const getStepContent = (step, props, stepperConfig) => {
  const stepConfig = stepperConfig.filter((config, index) => step === index)[0];
  const LazyComponent = importComponent(stepConfig.components?.component);
  return (
    <React.Suspense fallback={`Loading ${stepConfig?.label}, hang on...`}>
      <LazyComponent {...props} />
    </React.Suspense>
  );
};

const defaultFormData = {
  job: [],
  directorArray: [],
  instituteArray: [],
  applicantDetails: {},
  userDetails: {},
  applicationDetails: {},
  job:[],
  aspect:[],
  operations_manual:[],
  financial_details_resources:[],
  list_of_all_statutory_and_regulatory_compliances:[],
  management_of_human_resources:[],
  methodology_for_student_continuous_evaluation:[],
  methodology_for_industrial_interface:[],
  methodology_for_student_placement_assistance:[],
  students_admissions:[],
  health_and_safety_of_the_learners:[],
  feedback_mechanism:[],
  management_review:[],
  complaint_handling:[],
  library_details:[],
  centerDetails : [],
  hr:[]
};

export default function SideNav(props) {
  const classes = useStyles();
  const [hideNav, setHideNav] = useState(false);
  const [formData, setFormData] = React.useState(defaultFormData);
  const [stepperActiveStep, setActiveStep] = React.useState(0);
  const [completedStep, setCompletedStep] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [academicProgramsDetails] = useState(
    props?.history.location.state?.academicProgramDetails
  );
  // stepper config state
  const { config } = React.useContext(configContext);
  const [stepperConfig, setStepperConfig] = useState(getStepperConfig(config));
  const steps = getSteps(stepperConfig);

  React.useEffect(() => {
    if (props) {
      setFormData((prev) => {
        return {
          ...prev,
          userDetails: props?.history.location.state?.userDetails,
        };
      });
    }
  }, [props]);

  useEffect(() => {
    const userDetails = props.history.location.state?.userDetails;
    const applicationDetails = props.history.location.state?.applicationDetails;
    const applyingForSelf = userDetails?.applyingForSelf;
    const parentId = props.history.location.state?.ParentId;
    const email = props.history.location.state?.Email;
    let contactID;
    let appID;
    if (
      applicationDetails.draft === true ||
      formData.applicationDetails.draft === true
    ) {
      contactID = applicationDetails.studentId;
      appID = applicationDetails.AppID;
      localStorage.setItem("AppID",appID);
      if (contactID && appID) {
        setLoading(true);
        getApplicationById('', appID)
          .then((res) => {
            let applicantDetails = { ...res.data[0] };
            setFormData((prev) => {
              return {
                ...prev,
                //AcademicProgramsDetails: academicProgramsDetails,
                userDetails: userDetails,
                applicationDetails: applicationDetails,
                ParentId: parentId,
                applicantDetails: applicantDetails,
              };
            });
            //setProgressStatus(parseInt(applicantDetails.Application_Progress__c));
            setCompletedStep(parseInt(applicantDetails.Application_Progress__c));
            setLoading(false);

          })
          .catch((e) => {
            console.log(e);
            setLoading(false);
          });

        getJobRole(appID)
          .then((resp) => {
            if (resp.Status === '200' && resp.data) {
              setFormData((prev) => {
                return { ...prev, job: resp.data };
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });

        getDirector(appID)
          .then((resp) => {
            if (resp.Status === '200' && resp.data) {
              setFormData((prev) => {
                return {
                  ...prev,
                  directorArray: resp.data,
                };
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });

        getRecognitionOfInstitute(appID)
          .then((resp) => {
            if (resp.Status === '200' && resp.data) {
              setFormData((prev) => {
                return {
                  ...prev,
                  instituteArray: resp.data,
                };
              });
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }else{
        setLoading(false);
      }
      // getting all aspect
      getAspect(appID)
        .then((aspect) => {
          if (aspect && aspect.data.length > 0) {
            aspect.data.forEach((item) => {
              if(item.Value__c === 'true'){
                item.Value__c = 'YES';
              }else if(item.Value__c === 'false'){
                item.Value__c = 'NO';
              }
            });
            const aspect0 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.OPERATIONS_MANUAL);
            const aspect1 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.FINANCIAL_DETAILS_RESOURCES);
            const aspect2 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.LIST_OF_ALL_STATUTORY_AND_REGULATORY_COMPLIANCES);
            const aspect3 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.MANAGEMENT_OF_HUMAN_RESOURCES);
            const aspect4 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.METHODOLOGY_FOR_STUDENT_CONTINUOUS_EVALUATION);
            const aspect5 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.METHODOLOGY_FOR_INDUSTRIAL_INTERFACE); 
            const aspect6 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.METHODOLOGY_FOR_STUDENT_PLACEMENT_ASSISTANCE); 
            const aspect7 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.STUDENTS_ADMISSIONS); 
            const aspect8 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.HEALTH_AND_SAFETY_OF_THE_LEARNERS); 
            const aspect9 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.FEEDBACK_MECHANISM);
            const aspect10 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.MANAGEMENT_REVIEW);
            const aspect11 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.COMPLAINT_HANDLING);
            const aspect12 = aspect.data.filter(item=>item.Type__c === GLOBAL.ASPECT_TYPE.LIBRARY_DETAILS);
            if(aspect0 && aspect0.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  operations_manual:aspect0
                };
              });
            }
            if(aspect1 && aspect1.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  financial_details_resources:aspect1
                };
              });
            }
            if(aspect2 && aspect2.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  list_of_all_statutory_and_regulatory_compliances:aspect2
                };
              });
            }
            if(aspect3 && aspect3.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  management_of_human_resources:aspect3
                };
              });
            }
            if(aspect4 && aspect4.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  methodology_for_student_continuous_evaluation:aspect4
                };
              });
            }
            if(aspect5 && aspect5.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  methodology_for_industrial_interface:aspect5
                };
              });
            }
            if(aspect6 && aspect6.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  methodology_for_student_placement_assistance:aspect6
                };
              });
            }  
            if(aspect7 && aspect7.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  students_admissions:aspect7
                };
              });
            }  

            if(aspect8 && aspect8.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  health_and_safety_of_the_learners:aspect8
                };
              });
            }  

            if(aspect9 && aspect9.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  feedback_mechanism:aspect9
                };
              });
            }  
            if(aspect10 && aspect10.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  management_review:aspect10
                };
              });
            }  
            if(aspect11 && aspect11.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  complaint_handling:aspect11
                };
              });
            }  
            if(aspect12 && aspect12.length>0){
              setFormData((prev) => {
                return {
                  ...prev,
                  library_details:aspect12
                };
              });
            }  
          }
        })
        .catch((e) => {
          console.log(e);
        });

        //get all documents uploads
        getUploadDetails(appID).then((res) => {
          if(res && res.files.length > 0){
            setFormData((prev)=>{
              return {
                ...prev,
                files : res.files
              }
            })
          }
        })
        .catch(e=>{
          console.log(e);
        })  
         
    }
  }, []);

  useEffect(() => {
    setCompletedStep((prevCompletedStep) =>
      stepperActiveStep > prevCompletedStep
        ? stepperActiveStep
        : prevCompletedStep
    );
  }, [stepperActiveStep]);

  const stepperHandleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const stepperHandleBack = () => {
    //for loader
    setLoading(false);
    if (stepperActiveStep !== 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const goTostep = (step) => {
    if (completedStep >= step) {
      setActiveStep(step);
    }
  };
  const stepProps = {
    stepperHandleBack,
    stepperHandleNext,
    stepperActiveStep,
    stepperSteps: steps,
    formData,
    setFormData,
    instituteId: academicProgramsDetails?.Id,
    setLoading,
    loading,
    completedStep: completedStep,
  };

  return (
    <div>
      <Header
        // title={
        //   academicProgramsDetails?.academicProgram ||
        //   academicProgramsDetails?.academicprogram
        // }
        title={'Training Partner'}
        showRetrieve={false}
        setHideNav={setHideNav}
        hideNav={hideNav}
        hidden={true}
        isLogo={false}
        firstName={
          props.history.location.state?.userDetails?.First_Name ||
          props.history.location.state?.userDetails?.firstName
        }
        lastName={
          props.history.location.state?.userDetails?.Last_Name ||
          props.history.location.state?.userDetails?.lastName
        }
      ></Header>
      <div className={classes.root}>
        <Hidden xsDown>
          <Stepper
            orientation="vertical"
            style={{ marginTop: 2, padding: '24px 0px 24px 0px' }}
            activeStep={completedStep}
            // activeStep={stepperActiveStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label, index) => (
              // <div>
              <Step
                style={{ textAlign: 'left', cursor: 'pointer' }}
                key={index}
                onClick={() => goTostep(index)}
              >
                <StepLabel
                  className={clsx({
                    [classes.root3]: stepperActiveStep === index,
                  })}
                  classes={{
                    root: classes.root2,
                    label: classes.labelSteplabel,
                    active: classes.activeStepLabel,
                    completed: classes.completed,
                  }}
                  StepIconComponent={(props) => (
                    <ColorlibStepIcon
                      {...props}
                      completed={index < completedStep ? true : false}
                      stepperConfig={stepperConfig}
                    />
                  )}
                >
                  <Typography>
                    { index === completedStep ? `${parseInt((completedStep/steps.length)*100)} %` : ''}
                  </Typography>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Hidden>
        {hideNav && (
          <Stepper
            orientation="vertical"
            style={{ marginTop: 2, padding: '24px 0px 24px 0px' }}
            // activeStep={stepperActiveStep}
            activeStep={completedStep}
            connector={<ColorlibConnector />}
          >
            {steps.map((label, index) => (
              // <div>
              <Step
                style={{ textAlign: 'left' }}
                key={index}
                onClick={() => goTostep(index)}
              >
                <StepLabel
                  className={clsx({
                    [classes.root3]: stepperActiveStep === index,
                  })}
                  classes={{
                    root: classes.root2,
                    label: classes.labelSteplabel,
                    active: classes.activeStepLabel,
                    completed: classes.completed,
                  }}
                  // StepIconComponent={ColorlibStepIcon}
                  StepIconComponent={(props) => (
                    <ColorlibStepIcon
                      {...props}
                      completed={index < completedStep ? true : false}
                    />
                  )}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        )}
        <div style={{ width: '100%' }}>
          {stepperActiveStep === steps.length ? (
            <ThankYouPage {...stepProps} />
          ) : (
            <div style={{ margin: 8 }}>
              {getStepContent(stepperActiveStep, stepProps, stepperConfig)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
